import { TEndorsementsSchema } from 'transfix-form/forms/CarrierFleetInformation/components/EndorsementsModal/schema/EndorsementsSchema'
import { IEndorsements } from 'transfix-form/forms/CarrierFleetInformation/components/EndorsementsModal/types'
import { Maybe } from 'types/graphqlTypes'
import { TEndorsements } from '../types'

export const getEndorsementsDefaultValues = (
  endorsements: Maybe<TEndorsements['endorsements']>
): TEndorsementsSchema => {
  const endorsementsValues = endorsements ?? []
  return {
    tanker: endorsementsValues.includes(IEndorsements.TANKER),
    twic: endorsementsValues.includes(IEndorsements.TWIC),
    doubleTrailer: endorsementsValues.includes(IEndorsements.DOUBLE_TRAILER),
    hazmat: endorsementsValues.includes(IEndorsements.HAZMAT),
  }
}
